import React from 'react';

import './employeeitem.scss';


const EmployeeItem = ({ name = "", ball = "", dateReg = "", dateLog = "" }) => {

  return (

    <div className="flex boxer itemboxer">

    <div className="flex itemtext companies-columns__employees__box_one">
    
      <p className="employees-headtext">{name}</p>
    
    </div>

    <div className="flex itemtext companies-columns__employees__box_two">
      
      <p className="employees-headtext text-center">{ball}</p>
      
    </div>

    <div className="flex itemtext companies-columns__employees__box_three">
      
      <p className="employees-headtext text-center">{dateReg}</p>
      
    </div>

    <div className="flex itemtext companies-columns__employees__box_four">
      
      <p className="employees-headtext text-center">{dateReg}</p>
      
    </div>

  </div>

  );

}

export default EmployeeItem;